import { __assign } from "tslib";
import Globals from '../../Globals';
import { NeoTypes } from '../../AppServices';
import { Settings } from '../../Settings';
import NeoStrings from '../../Localisation/NeoStrings';
export var ModalResult;
(function (ModalResult) {
    ModalResult[ModalResult["Yes"] = 1] = "Yes";
    ModalResult[ModalResult["No"] = 2] = "No";
    ModalResult[ModalResult["Cancel"] = 3] = "Cancel";
})(ModalResult || (ModalResult = {}));
var ModalHelpers = /** @class */ (function () {
    function ModalHelpers() {
    }
    ModalHelpers.prototype.showMessage = function (title, message, resultValue) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            var button = { text: NeoStrings.modals.ok, onClick: function () { return resultValue ? resolve(resultValue) : resolve(); } };
            var options = { onClose: resolve };
            if (Settings.modal.okIsAccept) {
                options.acceptButton = button;
                options.closeButton = false;
            }
            else {
                options.closeButton = button;
            }
            _this.showModal(title, message, options);
        });
    };
    /**
     * Shows a message or component in a modal dialog. The user can click Yes or No, and the cancel button is hidden.
     * The returned promise will resolve with a ModalResult of Yes or No.
     * @param title The title in the header
     * @param message The message to display
     * @param onYes Callback to invoke when the user clicks yes.
     */
    ModalHelpers.prototype.showYesNo = function (title, message, onYes) {
        return this.showYesNoInternal(title, message, false, onYes);
    };
    /**
     * Shows a message or component in a modal dialog. The user can click Yes or No.
     * The close button is visible, and the modal can be dismissed by clicking the screen outside the modal.
     * The returned promise will resolve with a ModalResult of Yes or No or Cancel.
     * @param title The title in the header
     * @param message The message to display
     * @param onYes Callback to invoke when the user clicks yes.
     */
    ModalHelpers.prototype.showYesNoDismissible = function (title, message, onYes) {
        return this.showYesNoInternal(title, message, true, onYes);
    };
    ModalHelpers.prototype.showYesNoInternal = function (title, message, allowCancel, onYes) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            function onAccept() {
                if (onYes)
                    onYes();
                resolve(ModalResult.Yes);
            }
            _this.showModal(title, message, {
                onClose: function () { return resolve(ModalResult.No); },
                showCancelButton: allowCancel,
                acceptButton: { text: NeoStrings.modals.yes, onClick: onAccept },
                closeButton: { text: NeoStrings.modals.no, onClick: function () { return resolve(ModalResult.No); } }
            });
        });
    };
    /**
     * Shows a message or component in a modal dialog. The user can click Ok or Cancel.
     * The returned promise will resolve with a ModalResult of Yes or Cancel.
     * @param title The title in the header
     * @param message The message to display
     * @param model Optional model to use for validating if the accept button can be clicked.
     */
    ModalHelpers.prototype.showOkCancel = function (title, message, model) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.showModal(title, message, {
                onClose: function () { return resolve(ModalResult.Cancel); },
                acceptButton: { text: NeoStrings.modals.ok, onClick: function () { return resolve(ModalResult.Yes); } },
                closeButton: __assign(__assign({}, Settings.modal.cancelButton), { text: NeoStrings.modals.cancel, onClick: function () { return resolve(ModalResult.Cancel); } }),
                formProps: { model: model },
            });
        });
    };
    /**
     * Shows a message or component in a modal dialog. The user can click Yes, No, Cancel, or the close button.
     * The returned promise will resolve with a ModalResult of Yes, No or Cancel. The close button will result in ModalResult.Cancel.
     * @param title The title in the header
     * @param message The message to display
     * @param onYes Callback to invoke when the user clicks yes.
     */
    ModalHelpers.prototype.showYesNoCancel = function (title, message, onYes) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            function onAccept() {
                if (onYes)
                    onYes();
                resolve(ModalResult.Yes);
            }
            _this.showModal(title, message, {
                onClose: function () { return resolve(ModalResult.Cancel); },
                buttons: [
                    __assign(__assign({}, Settings.modal.acceptButton), { text: NeoStrings.modals.yes, onClick: onAccept }),
                    __assign(__assign({}, Settings.modal.closeButton), { text: NeoStrings.modals.no, onClick: function () { return resolve(ModalResult.No); } }),
                    __assign(__assign({}, Settings.modal.cancelButton), { text: NeoStrings.modals.cancel, onClick: function () { return resolve(ModalResult.Cancel); } })
                ]
            });
        });
    };
    /**
     * Creates and displays a read-only static modal dialog.
     * @param title The title in the header
     * @param message The message or component to display
     * @param modalOptions Options
     */
    ModalHelpers.prototype.showModal = function (title, message, modalOptions) {
        return Globals.appService.get(NeoTypes.UI.ModalStore).addModal(title, message, modalOptions);
    };
    return ModalHelpers;
}());
export var ModalUtils = new ModalHelpers();
